module.exports = __webpack_public_path__ + "img/63.1aa5bf84.jpg";